import React from 'react';
import { ShieldCheckIcon } from 'lucide-react';
import { Section, Eyebrow, Heading } from '../Section';
import { CTAButton } from '../CTAButton';
export function Guarantee() {
  return <Section dark data-id="element-175" data-mp="24nghu5r3re6w">
      <Eyebrow data-id="element-176" data-mp="24myc8iijvnmb">Try it for 7 days — risk free</Eyebrow>
      <Heading data-id="element-177" data-mp="24ldj8xbvwcqk">7-Day satisfaction guarantee</Heading>

      <div className="mt-8 rounded-2xl border border-spark/40 bg-ink-700 p-6 text-center" data-id="element-178" data-mp="29eyistt4lerv">
        <span className="mx-auto flex h-16 w-16 items-center justify-center rounded-full bg-spark/15" data-id="element-179" data-mp="2edt4c3ih9hfo">
          <ShieldCheckIcon className="h-9 w-9 text-spark" aria-hidden="true" data-id="element-180" data-mp="2jb1na6bg9phz" />
        </span>
        <p className="mt-5 text-[15px] leading-relaxed text-zinc-300" data-id="element-181" data-mp="2oaxnduh10ws9">
          Go through the Master Volumes, use the decision maps and explore the system during your
          first seven days. If you feel that Weld Decision System™ isn’t what you expected, simply
          contact us within 7 days and we’ll refund your purchase according to the guarantee terms.
        </p>
        <p className="mt-5 font-display text-xl font-extrabold uppercase leading-tight text-white sm:text-2xl" data-id="element-182" data-mp="3sl6lrywy9fvv">
          No risk. No long forms. No complicated process.
        </p>
        <p className="mt-2 text-[15px] font-semibold text-flame-400" data-id="element-183" data-mp="3ivmzeja133w9">
          You don’t have to take the risk. We do.
        </p>
      </div>

      <div className="mt-8" data-id="element-184" data-mp="3dxlfxx8ox2k9">
        <CTAButton label="TRY IT WITH ZERO RISK FOR 7 DAYS" data-id="element-185" data-mp="3dyd9z3mn2s8f" />
      </div>
    </Section>;
}